export const daysPerWeek = 7;

export const monthsPerYear = 12;
